import type { PaymentHistoryRowType } from '../../api/types';

export const PAYMENT_TYPE_ORDER: PaymentHistoryRowType[] = [
  'subscription',
  'pack',
  'complimentary',
  'refund',
  'dispute',
  'unknown',
];

export const PAYMENT_TYPE_LABELS: Record<PaymentHistoryRowType, string> = {
  subscription: 'Subscriptions',
  pack: 'Track packs',
  complimentary: 'Complimentary grants',
  refund: 'Refunds',
  dispute: 'Disputes',
  unknown: 'Other',
};
